module.exports = __webpack_public_path__ + "static/img/JD963774380491(1).3631256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/JD963774380491(1).png
// module id = OZTo
// module chunks = 1